import type { Worklist } from "../atoms/labelingAtoms";
import type { Surface } from "../constants/viewerActions";

/** What a standalone CaseViewer (worklist / triage / dictation) declares. */
export const DEFAULT_CASE_VIEWER_SURFACES: readonly Surface[] = ["dictation"];

/**
 * Surfaces CaseViewer writes: its host's base surfaces, plus "prediction-masks"
 * while the AI mask toggle is available.
 */
export function caseViewerSurfaces(base: readonly Surface[], predictionMasks: boolean): Surface[] {
  return predictionMasks ? [...base, "prediction-masks"] : [...base];
}

/**
 * Viewer surfaces a labeling worklist declares (toolbar, context menu, help
 * dialog and the segmentation camera-snap gate all read them). A switch with an
 * exhaustiveness check so a new project_type variant fails the type-check
 * instead of silently inheriting the conditions UI.
 */
export function labelingViewerSurfaces(
  projectType: Worklist["project_type"],
  readOnly: boolean,
): Surface[] {
  if (readOnly) return ["labeling-conditions"];
  switch (projectType) {
    case "segmentation":
    case "segmentation_study":
      return ["labeling-seg"];
    case "reporting":
      return ["labeling-reporting"];
    case "both":
      return ["labeling-seg", "labeling-reporting"];
    case "classification":
    case undefined:
      return ["labeling-conditions"];
    case "joint_review":
      // Joint reviews open on their own pages (labelingViewerRoute), with no tools.
      return [];
    default: {
      const _exhaustive: never = projectType;
      void _exhaustive;
      return ["labeling-conditions"];
    }
  }
}
